export default __webpack_public_path__ + "media/aws_logo.d1d1fb06.svg";